
import { Organization } from "@/types/subscription";
import { Label } from "@/components/ui/label";
import { Building } from "lucide-react";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";

type OrganizationSelectorProps = {
  organizations: Organization[];
  selectedOrgId: string;
  onSelect: (orgId: string) => void;
  isLoading: boolean;
};

const OrganizationSelector = ({
  organizations,
  selectedOrgId,
  onSelect,
  isLoading,
}: OrganizationSelectorProps) => {
  return (
    <div className="mb-6">
      <Label htmlFor="organization" className="block text-sm font-medium text-gray-700 mb-1">
        Organisation
      </Label>
      <Select
        value={selectedOrgId}
        onValueChange={(value) => onSelect(value)}
        disabled={isLoading || organizations.length <= 1}
      >
        <SelectTrigger className="w-full" id="organization">
          <SelectValue placeholder="Sélectionner une organisation" />
        </SelectTrigger>
        <SelectContent>
          {organizations.map((org) => (
            <SelectItem key={org.id} value={org.id}>
              <div className="flex items-center">
                <Building className="h-4 w-4 mr-2 text-gray-500" />
                {org.name} ({org.plan})
              </div>
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
};

export default OrganizationSelector;
